// Types extracted from serviceRequest to avoid exporting the lazy implementation module directly.
// Keeping these lightweight so they can be safely re-exported non-lazily.

export interface RequestOptions {
    requestUrlBase: string;
    method: HttpMethod;
    body?: BodyInit;
    queryParams?: { [key: string]: string };
    headers?: Headers;
    /**
     * PAS-only callback from the prepared string body to deterministic replay-identity text,
     * not a hash. The original body is still sent. Preserve semantic inputs and array order;
     * omit only endpoint-confirmed tracking fields and credentials. Throw on invalid input.
     * When absent, the original body is used for replay identity.
     */
    getPasRequestBody?: (body: string) => string;
}

export type HttpMethod =
    | 'POST'
    | 'PATCH'
    | 'PUT'
    | 'GET'
    | 'DELETE'
    | 'HEAD'
    | 'OPTIONS'
    | 'CONNECT'
    | 'TRACE';

export enum AuthEndpoint {
    MCPS = 'https://teams.cloud.microsoft/6bc3b958-689b-49f5-9006-36d165f30e00',
}
